import { requestV3 } from '@/libs/ajax';
import qs from 'qs'
import axios from 'axios'
const CancelToken = axios.CancelToken;

export function testApi(data) {
    return requestV3({
        url: '/test',
        method: 'get',
    })
}
/**
 * 获取任务列表
 * @param {*} params 
 * @returns 
 */
export function getBatchListApi(params) {
    return requestV3({
        url: '/batch/list',
        method: 'get',
        params
    })
}
/**
 * 获取查询账户列表
 * @param {*} params 
 * @returns 
 */
export function getBatchQueryAccountListApi(params) {
    return requestV3({
        url: '/batch/select/account',
        method: 'get',
        params
    })
}
/**
 * 获取产品列表
 * @param {*} params 
 * @returns 
 */
export function getBatchQueryAppListApi(params) {
    return requestV3({
        url: '/batch/select/app',
        method: 'get',
        params
    })
}
/**
 * 获取创建人列表
 * @param {*} params 
 * @returns 
 */
export function getBatchQueryUserListApi(params) {
    return requestV3({
        url: '/batch/select/user',
        method: 'get',
        params
    })
}
/**
 * 获取创建部门列表
 * @param {*} data 
 * @returns 
 */
export function getBatchQueryDepartmentListApi(params) {
    return requestV3({
        url: '/batch/select/group',
        method: 'get',
        params
    })
}
/**
 * 获取任务汇总信息
 * @param {*} data 
 * @returns 
 */
export function getBatchTotalDataApi(params) {
    return requestV3({
        url: '/batch/total',
        method: 'get',
        params
    })
}
/**
 * 任务详情
 * @param {*} data 
 * @returns 
 */
export function getBatchTaskInfoApi(params) {
    return requestV3({
        url: '/batch/task/info',
        method: 'get',
        params
    })
}
/**
 * 获取素材规格信息
 * @param {*} data 
 * @returns 
 */
export function getBatchMaterialInfoApi(params) {
    return requestV3({
        url: '/batch/material/info',
        method: 'get',
        params
    })
}
/**
 * 更新转化名称
 * @param {*} data 
 * @returns 
 */
export function updateBatchConversionNameApi(data) {
    return requestV3({
        url: '/batch/conversion/name/update',
        method: 'post',
        data: qs.stringify(data)
    })
}
/**
 * 获取转化名称
 * @param {*} params 
 * @returns 
 */
export function getBatchConversionNameApi(params) {
    return requestV3({
        url: '/batch/conversion/name/list',
        method: 'get',
        params
    })
}



/**
 * 获取出价均值
 * @param {*} data 
 * @returns 
 */
export function getBatchConversionPriceApi(params) {
    return requestV3({
        url: '/batch/conversion/price',
        method: 'get',
        params
    })
}
/**
 * 任务重试
 * @param {*} data 
 * @returns 
 */
export function retryBatchTaskApi(params) {
    return requestV3({
        url: '/batch/task/retry',
        method: 'get',
        params
    })
}

/**
 * 获取渠道包列表
 * @param {*} data 
 * @returns 
 */
export function BatchPackageListApi(params) {
    return requestV3({
        url: '/batch/channel/package/list',
        method: 'get',
        params
    })
}
/**
 * 更新渠道包列表
 * @param {*} data 
 * @returns 
 */
export function BatchPackageListUpdateApi(data) {
    return requestV3({
        url: '/batch/channel/package/update',
        method: 'post',
        data: qs.stringify(data)
    })
}
/**
 * 获取智能分包列表
 * @param {*} data 
 * @returns 
 */
export function BatchIntelligentPackageListApi(params) {
    return requestV3({
        url: '/batch/intelligent/package/list',
        method: 'get',
        params
    })
}
/**
 * 更新智能分包列表
 * @param {*} data 
 * @returns 
 */
export function BatchIntelligentPackageListUpdateApi(data) {
    return requestV3({
        url: '/batch/intelligent/package/update',
        method: 'post',
        data: qs.stringify(data)
    })
}
/**
 * 获取行业分类
 * @param {*} data 
 * @returns 
 */
export function BatchIndustryInfoApi(params) {
    return requestV3({
        url: '/batch/industry/info/list',
        method: 'get',
        params
    })
}
/**
 * 获取维纳斯落地页
 * @param {*} data 
 * @returns 
 */
export function BatchPromotionVenusApi(params) {
    return requestV3({
        url: '/batch/promotion/venus/list',
        method: 'get',
        params
    })
}
/**
 * 获取工单素材
 * @param {*} data 
 * @returns 
 */
export function getWorkMaterialListApi(data, callback) {
    return requestV3({
        url: '/batch/work/order/material/list',
        method: 'post',
        data: qs.stringify(data),
        cancelToken: new CancelToken(function executor(c) {
            // executor 函数接收一个 cancel 函数作为参数
            callback&& callback(c);
          })
    })
}
/**
 * 获取媒体信息
 * @param {*} params 
 * @returns 
 */
export function getMaterialInfoApi(params) {
    return requestV3({
        url: '/batch/material/info',
        method: 'get',
        params
    })
}
/**
 * 获取定向包
 * @param {*} params 
 * @returns 
 */
export function getTargetingPackageListApi(params) {
    return requestV3({
        url: '/batch/targeting/package/list',
        method: 'get',
        params
    })
}
/**
 * 搜索配置
 * @param {*} params 
 * @returns 
 */
export function getSearchConfigApi(params) {
    return requestV3({
        url: '/batch/work/order/config',
        method: 'get',
        params
    })
}
/**
 * 获取转化名称列表
 * @param {*} data 
 * @returns 
 */
export function getConversionNameListApi(data) {
    return requestV3({
        url: '/batch/get/conversion/list',
        method: 'post',
        data: qs.stringify(data)
    })
}
/**
 * 更新转化名称列表
 * @param {*} data 
 * @returns 
 */
export function updateConversionNameListApi(data) {
    return requestV3({
        url: '/batch/conversion/update',
        method: 'post',
        data: qs.stringify(data)
    })
}
/**
 * 获取深度转化名称列表
 * @param {*} params 
 * @returns 
 */
export function getDeepConversionNameApi(params) {
    return requestV3({
        url: '/batch/get/deep/conversion/list',
        method: 'get',
        params
    })
}
/**
 * 预览-详情列表(点击生成预览后)
 * @param {*} params 
 * @returns 
 */
export function getBatchPreviewListApi(params) {
    return requestV3({
        url: '/batch/preview/list',
        method: 'get',
        params
    })
}
/**
 * 任务详情
 * @param {*} params 
 * @returns 
 */
export function getTaskDetailApi(params) {
    return requestV3({
        url: '/batch/detail/list',
        method: 'get',
        params
    })
}
/**
 * 预览-目标账户与产品(点击生成预览后)
 * @param {*} params 
 * @returns 
 */
export function getBatchPreviewInfoApi(params) {
    return requestV3({
        url: '/batch/preview/info',
        method: 'get',
        params
    })
}

export function getTaskDetailTotalApi(params) {
    return requestV3({
        url: '/batch/detail/info',
        method: 'get',
        params
    })
}
/**
 * 获取工单页表
 * @param {*} data 
 * @returns 
 */
export function getWorkOrderListApi(data) {
    return requestV3({
        url: '/batch/work/order/list',
        method: 'post',
        data: qs.stringify(data)
    })
}
/**
 * 更新定向包
 * @param {*} data 
 * @returns 
 */
export function updatePackageListApi(data) {
    return requestV3({
        url: '/batch/targeting/package/update',
        method: 'post',
        data: qs.stringify(data)
    })
}
/**
 * 获取产品信息
 * @param {*} params 
 * @returns 
 */
export function getProductInfoApi(params) {
    return requestV3({
        url: '/batch/product/info',
        method: 'get',
        params
    })
}


